module.exports = __webpack_public_path__ + "media/src/img/helpsum-cloud-a5cd6a56d407d3a433b6d0a728b0d31d.png";